export default __webpack_public_path__ + "fc6acb82f223d16a6cc4b2ec2877d6b5.svg";